import React from 'react';
import { BRAND, stats, testimonials } from '../data/eatWellContent';
type TestimonialsSectionProps = {
  /** The first appearance carries the statistics strip. */
  variant?: 'primary' | 'compact';
  id?: string;
};
export function TestimonialsSection({
  variant = 'primary',
  id = 'proof'
}: TestimonialsSectionProps) {
  const isPrimary = variant === 'primary';
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby={`${id}-title`} data-id="element-211" data-mp="1d1uo7j2cprp8">
      <div className="mx-auto max-w-6xl px-5" data-id="element-212" data-mp="1i1h09p6g11wg">
        {isPrimary ? <h2 id={`${id}-title`} className="sr-only" data-id="element-213" data-mp="1hyl4a6e5onan">
            What people are saying about {BRAND}
          </h2> : <h2 id={`${id}-title`} className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-214" data-mp="1828dbg9zwnjl">
            What people are saying about {BRAND}
          </h2>}

        {isPrimary && <dl className="grid grid-cols-2 gap-y-6 border-b border-charcoal-600 pb-10 sm:grid-cols-4" data-id="element-215" data-mp="2v1axiofabgk9">
            {stats.map(s => <div key={s.label} className="text-center" data-id="element-216" data-mp="2q1q1alri1mb8">
                <dd className="font-display text-2xl font-semibold text-champagne sm:text-3xl" data-id="element-217" data-mp="34r4b1uyzm5r5">
                  {s.value}
                </dd>
                <dt className="mx-auto mt-1 max-w-[8rem] text-[9px] font-medium uppercase tracking-[0.16em] text-muted sm:text-[10px]" data-id="element-218" data-mp="2zst2roocc3b1">
                  {s.label}
                </dt>
              </div>)}
          </dl>}

        <ul className={`grid gap-3 sm:grid-cols-3 ${isPrimary ? 'mt-10' : 'mt-8'}`} data-id="element-219" data-mp="2m0wdrthyy9iv">
          {testimonials.map(t => <li key={t.name} className="flex flex-col border border-charcoal-600 bg-charcoal-800 p-5" data-id="element-220" data-mp="2h1jqj7n6r0fr">
              <div className="flex items-center gap-3" data-id="element-221" data-mp="18uaqlkwzh4o">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-champagne/40 text-[11px] font-semibold tracking-[0.08em] text-champagne" aria-hidden="true" data-id="element-222" data-mp="3shrkikojx3ft">
                  {t.initials}
                </span>
                <span className="text-[10px] tracking-[0.2em] text-champagne" aria-label="5 out of 5 stars" data-id="element-223" data-mp="ddzwik7tcu9z">
                  ★★★★★
                </span>
              </div>
              <blockquote className="mt-3.5 text-[13px] leading-relaxed text-ivory-100" data-id="element-224" data-mp="3gvi1mjw7bn6p">
                “{t.quote}”
              </blockquote>
              <footer className="mt-auto pt-4 text-[9px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-225" data-mp="3qrbbtwmg74lb">
                {t.name}
                <span className="ml-2 text-ivory-300" data-id="element-226" data-mp="3vjcsrvuk9jho">{t.role}</span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}